import React, { memo, useCallback } from 'react';
import Squircle from 'design-system/Squircle';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
import useColors from 'hooks/useColors';
import AnalyticsRow from './AnalyticsRow';
import IconOtherMerchant from '../../icons/IconOtherMerchant';
const RowMerchant = ({ merchant, blurValue, onPress }) => {
    const press = useCallback(() => {
        onPress?.({ type: 'merchant', data: merchant });
    }, [merchant, onPress]);
    const colors = useColors();
    return (<AnalyticsRow displayName={merchant.displayName} total={merchant.total} count={merchant.transactionsCount} currency={merchant.currency} onPress={onPress ? press : undefined} icon={merchant.id === -1 ? (<Squircle color={colors.elements.brand}>
            <IconOtherMerchant />
          </Squircle>) : (<TransactionLogo R44 transaction={{ category: merchant.category, merchant }}/>)} blurValue={blurValue}/>);
};
export default memo(RowMerchant);
